//Константы из SetupView
export default {
  classes: {
    table: { name: "Table", defaultTitle: "New table" },
    list: { name: "List", defaultTitle: "New list" },
    tree: { name: "Tree", defaultTitle: "New tree" },
    graph: { name: "Graph", defaultTitle: "New graph" },
    multi: { name: "Set", defaultTitle: "New set" },
    html: { name: "Custom views", defaultTitle: "New custom view" },
    cmp: { name: "Comparison", defaultTitle: "New comparison" },
    exporter: { name: "Exporter", defaultTitle: "New exporter" }
  },

  props: {
    hide_in_list: "Hide from main list",

    view_title: "View title",
    view_description: "View description",

    src_endpoint: "SPARQL endpoint",
    src_query: "SPARQL query",
    page_size: "Page size (records per page)",

    tree_width: "Tree width, %",

    link_view: "Linked view",
    link_col: "Link",

    border: "Border",
    border_width: "Border width, px",
    border_color: "Border color",

    col_field: "Data field",
    col_data: "Example value",
    col_uri: "URI field",
    col_show: "Show column",
    alpha_col: "Field for alphabetic sorting",
    col_title: "Column header",
    col_html: "Render as HTML",
    col_group: "Group by field",
    col_separator: "Separator when merging",
    col_width: "Column width",
    col_width_min: "Minimum column width",

    col_foreground: "Font color",
    col_background: "Background color",
    font_size: "Font size, px",
    font_style: "Font style",
    font_weight: "Font weight",
    alignment: "Alignment",

    graph: "Graph name",
    typeAsSuperClass: "Type defines superclass",
    show_type: "Display type",
    typesFilter: "List of URIs to display as nodes",
    linksFilter: "List of URIs to display as edges",
    labelsFilter: "List of URIs containing labels",
    createTypes: "Types to create",
    namespaces: "Namespaces list",
    extra_options: "Extra options string",

    gen_endpoint: "Generator endpoint",
    sparqls_var_name: "Variable name",
    sparqls_query: "Query body",
    sparqls_endpoint: "Query endpoint",
    templates_file_name: "File name",
    templates_content: "File content",
    gen_type: "Generation type",

    html_code: "Custom HTML code"
  },
  props_extra: {
      tree_width: "Tree width, %",
      src_query_root: "SPARQL query for root tree nodes",

      graph_name: "Graph name",
      type_as_superclass: "Type defines superclass",
      show_type: "Display type",

      graph_types_filter: "List of URIs to display as nodes",
      graph_links_filter: "List of URIs to display as edges",
      graph_labels_filter: "List of URIs containing labels",
      graph_create_types: "Types to create",

      namespaces: "Namespaces list",
      extra_options: "Extra options string",

      next_multi_item: "Next set item",
      linked_view: "Linked view",

      html_code: "Custom HTML code",

      graph_list: "Graph list for comparison",

      gen_endpoint: "Generator endpoint",

      sparqls: "SPARQL queries with parameters",
      sparqls_var_name: "Variable name",
      sparqls_query: "Query body",
      sparqls_endpoint: "Query endpoint",

      templates: "Templates with parameters",
      templates_file_name: "File name",
      templates_content: "File content",

      gen_type: "Generation type",
      
      src_query_children: "SPARQL query for child tree nodes",
      uri: "URI",
      background_color: "Background color"
  },
  comments: {
    src_query_root: "The query must return at least ?URI",
    src_query_cmp: "Specify %CMP_FROM% in the query — what to compare, %CMP_TO% — with what.",
    src_query_children: "The query must return at least ?URI and ?PARENT_URI. Use ?PARENT_URI to substitute the parent node ID.",
    page_size: "Used for pagination. 0 — return all records.",
    namespaces: "Namespaces list",
    extra_options: "Extra options string",
    html_code: "Custom HTML code"
  },
  common: {
    hidden_suffix: " (hidden)"
  },
  common_extra: {
      subtree: "Next tree level",
      columns: "Data representation",
      border: "Border",
      no_value: "none"
  },
  defaults: {
    untitled_view: "Untitled view"
  }

}
